import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'arrow-badge-right', 'ArrowBadgeRight', [["path",{"d":"M13 7h-6l4 5l-4 5h6l4 -5z","key":"svg-0"}]]);